import { get } from 'epics/ajax';
import { contextPath } from 'util/history';

export interface ServiceProjectRequestPermissionsResponseType {
    isEnabled: boolean;
    canCreateProject: boolean;
}

export const serviceProjectRequestPermissions = (basePath: string = contextPath) => {
    const uri = `${basePath}/rest/servicedesk/1/customer/new-service-desk-request/permissions`;

    const headers = {
        Accept: 'application/json',
    };

    return get(uri, headers)
        .map(({ response }) => response)
        .catch((e) => Promise.reject(e));
};
